$(function() {
    // ajax params
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'post_ajax',
            postType: 'post',
            url: myajax,
            catId: 'all',
            currentPage: 1,
            order: 'DESC'
        };

    // Ajax helper function
    function loadPosts(paramObj) {
        let postsOffsetTop = $('.js-posts-list').offset().top - $('.page-header').height();
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',
            beforeSend() {
                $('.js-posts-list').css({ 'opacity': '.3', 'pointer-events': 'none' });
            },
            success(data) {
                $('html, body').animate({ scrollTop: `${postsOffsetTop}` }, 500);
                $('.js-posts-list').html(data);
            },
            complete() {
                $('.js-posts-list').css({ 'opacity': '1', 'pointer-events': 'auto' });
            }
        });
    }

    // Filter
    $('.js-posts-select').on('change', function H() {
        let $this = $(this),
            $thisArea = $this.attr('data-area'),
            $thisVal = $this.val();
        if ($thisArea === 'filter') {
            paramObj.catId = $thisVal === 'all' ? 'all' : Number($thisVal);
        } else if ($thisArea === 'sort-by') {
            paramObj.order = $thisVal;
        }
        loadPosts(paramObj);
    });

    //Pagination
    $('.js-posts-list').on('click', '.page-numbers', function H(e) {
        let $this = $(this),
            catID = $this.parents('.js-post-pagination').data('cat-id');
        e.preventDefault();
        if (catID) {
            paramObj.catId = catID ? catID : 'all';
        }
        paramObj.currentPage = Number($(this).html());
        if ($(this).hasClass('next')) {
            paramObj.currentPage =+ Number($('.current').html()) + 1;
        }
        if ($(this).hasClass('prev')) {
            paramObj.currentPage = +Number($('.current').html()) - 1;
        }
        loadPosts(paramObj);
    });
});